// Research hero — clinical/lab-coded treatment of the VOYA9 brand.
// Sterile whites + navy + monospace accents — distinct from the warm
// peach/ink magazine voice of the main marketing site, but unmistakably
// the same brand. Used at the top of /research for both authed and
// unauthed visitors.
import { C } from "@/lib/brand";
import { Eyebrow, Headline } from "@/components/Editorial";

// Brand-extension token: navy used only on research surfaces.
export const RESEARCH_NAVY = "#1F3349";
export const RESEARCH_NAVY_DEEP = "#0F1B2A";

export default function ResearchHero({ qualityLine, supplierLine }) {
  return (
    <section
      data-testid="research-hero"
      style={{
        background: C.pure,
        color: RESEARCH_NAVY_DEEP,
        padding: "96px 24px 72px",
        borderBottom: `1px solid ${C.warmGray4}`,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Lab grid pattern — very faint, gives the surface a "data plate"
          feel without competing with the headline. */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(to right, rgba(31,51,73,0.04) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(31,51,73,0.04) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
          pointerEvents: "none",
        }}
      />
      <div style={{ position: "relative", maxWidth: 1100, margin: "0 auto" }}>
        <div
          style={{
            fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace',
            fontSize: 10,
            letterSpacing: "0.3em",
            color: RESEARCH_NAVY,
            textTransform: "uppercase",
            marginBottom: 28,
            display: "flex",
            gap: 14,
            alignItems: "center",
          }}
          data-testid="research-hero-batch-strip"
        >
          <span>VY9 ▪ RESEARCH</span>
          <span style={{ width: 24, height: 1, background: RESEARCH_NAVY, opacity: 0.4 }} />
          <span>FOR RESEARCH PURPOSES</span>
        </div>
        <Eyebrow color={RESEARCH_NAVY} testId="research-hero-eyebrow">★ COMPOUND CATALOGUE</Eyebrow>
        <div style={{ height: 24 }} />
        <Headline
          before="THE FULL"
          italic="library."
          color={RESEARCH_NAVY_DEEP}
          italicColor={RESEARCH_NAVY}
          size={72}
        />
        <p
          data-testid="research-hero-quality"
          style={{
            marginTop: 32,
            maxWidth: 620,
            fontSize: 16,
            lineHeight: 1.65,
            color: C.warmGray,
          }}
        >
          {qualityLine || "Batch tested in US labs for identity, purity, and consistency."}
          {" "}
          {supplierLine || "Supplied to physicians throughout the United States."}
        </p>
      </div>
    </section>
  );
}
